import { memdbRequest } from "./index.js";
export function getTeam({ teamId, teamnumber = 1, params, }) {
    return memdbRequest.get(`/tournament/team/${teamId}/teamnumber/${teamnumber}`, { params });
}
export function getClubTeams({ clubId, schema }) {
    return memdbRequest.get("/tournament/team", {
        params: { clubid: clubId, schema },
    });
}
export function getClubTeamsByClubIds({ clubIds, endDate, tournamentTypes, schema, }) {
    return memdbRequest.get("/tournament/team", {
        params: {
            clubids: clubIds.join(","),
            enddate: endDate,
            tournamenttypes: tournamentTypes.join(","),
            schema,
        },
    });
}
export const createTeam = (body) => memdbRequest.post("/tournament/team", { body });
export const updateTeam = (team) => memdbRequest.post(`/tournament/team/${team.id}`, {
    body: { team },
});
export const addPlayer = (reg) => memdbRequest.post(`/tournament/team/${reg.orgid}/player`, { body: { reg } });
export const removePlayer = ({ teamId, memberId, }) => memdbRequest.delete(`/tournament/team/${teamId}/player/${memberId}`);
//# sourceMappingURL=team.js.map